<div class="">
    <mat-dialog-content class="">
            <button (click)="closeDialogue()" class="m-show m-back-arrow" type="button"><img src="assets/img/m-back-arrow-dark.svg" alt=""></button>
        <div class="font-14 heading">
            <h4>{{ data?.message }}<span><button class="closeButton m-hide" (click)="closeDialogue()">X</button></span></h4>
        </div>
        <div class="assessment_py-10 font-8">
            {{ data?.message2 }}
        </div>
        <form [formGroup]="forgotForm">
            <div class="form-group phn-input">
        <input class="form-control" type="text" formControlName="phone" placeholder="+91 Phone Number" phone-number readonly>
     </div>
     <button class="btn btn-primary btn-block" type="button" (click)="sendOtp()">SEND OTP</button>
        </form>
    </mat-dialog-content>
    
</div>